export default __webpack_public_path__ + "media/zurb/img/home/home-contact-bg-063983c1649ba697ac6c9950faccfffc.png";